import template from './get-started.jade';

export default function GetStartedConfig($stateProvider) {
  'ngInject';
  $stateProvider.state('app.get-started', {
    url: '/get-started',
    abstract: true,
    views: {
      '@': {
        template: template,
        controller: 'GetStartedController as getStartedCtrl',
      },
    },
    data: {
      permissions: '!signedIn && signingUp',
    },
  });
}
